import { render, staticRenderFns } from "./AbkOfferTextSection.vue?vue&type=template&id=0958e7aa&scoped=true&"
import script from "./AbkOfferTextSection.vue?vue&type=script&lang=js&"
export * from "./AbkOfferTextSection.vue?vue&type=script&lang=js&"
import style0 from "./AbkOfferTextSection.vue?vue&type=style&index=0&id=0958e7aa&lang=scss&scoped=true&"
import style1 from "./AbkOfferTextSection.vue?vue&type=style&index=1&id=0958e7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0958e7aa",
  null
  
)

export default component.exports